/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Bo as Bo,
  rec_Componente_qD_113_68 as Componente_qD_113_68,
  rec_DetalleReunion as DetalleReunion,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_NuevaReunion as NuevaReunion,
  rec_Paginacion as Paginacion,
  rec_Qx as Qx,
  rec_React as React,
  rec_Ro as Ro,
  rec_Ti as Ti,
  rec_Yx as Yx,
  rec_api as api,
  rec_ii as ii,
  rec_pS as pS,
  rec_wr as wr,
} from "../../runtime/index.jsx";
export function ReunionesProyecto({ proyecto: e, proyectosDelArea: t = [] }) {
  let n = !e.id,
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(0),
    [s, c] = (0, React.useState)(0),
    [l, u] = (0, React.useState)([]),
    [f, p] = (0, React.useState)(!0),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)(!1),
    [v, y] = (0, React.useState)(null),
    [b, x] = (0, React.useState)(null),
    S = !accionProyecto(e, `planner.reuniones.crear`),
    C = (0, React.useCallback)(async () => {
      p(!0);
      try {
        if (n) {
          let t = (await api(`/reuniones?unidad=${e.unidadId}`)) ?? [];
          (i(t), c(t.length), u([]));
        } else {
          let [t, n] = await Promise.all([
            api(`/reuniones?proyecto=${e.id}&pagina=${a}&tamano=25`),
            api(`/metas?proyecto=${e.id}`),
          ]);
          (i(t.items),
            c(t.total),
            a > 0 && t.items.length === 0 && o(a - 1),
            u(n));
        }
        h(``);
      } catch (e) {
        h(e.message);
      } finally {
        p(!1);
      }
    }, [n, e.id, e.unidadId, a]);
  return (
    (0, React.useEffect)(() => {
      C();
    }, [C]),
    f ? (
      <div
        className={`flex items-center gap-2 text-sm text-(--text)`}
        children={[
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          }),
          ` Cargando…`,
        ]}
      />
    ) : (
      <div
        className={`flex flex-col gap-4`}
        children={[
          <div
            className={`flex items-center justify-between`}
            children={[
              <span
                className={`text-sm text-(--text)`}
                children={[s, ` reuniones`]}
              />,
              !S && (
                <button
                  type={`button`}
                  onClick={() => _(!0)}
                  className={Ro}
                  children={[
                    <Ti className={`mr-1 inline h-4 w-4`} />,
                    ` Nueva reunión`,
                  ]}
                />
              ),
            ]}
          />,
          <EstadoError mensaje={m} onReintentar={C} />,
          r.length === 0 ? (
            <div
              className={`rounded-2xl border border-dashed border-(--border) p-10 text-center`}
              children={[
                (0, JSXRuntime.jsx)(wr, {
                  className: `mx-auto h-8 w-8 text-(--text)`,
                }),
                <p
                  className={`mt-2 text-sm text-(--text)`}
                  children={`Todavía no hay ninguna. Cuando el equipo se junte, anotala acá.`}
                />,
              ]}
            />
          ) : (
            <ul
              className={`animar-cascada flex flex-col gap-3`}
              children={r.map((e) => (
                <li
                  key={e.id}
                  children={
                    <button
                      type={`button`}
                      onClick={() => y(e.id)}
                      className={`${Bo} w-full text-left transition hover:shadow-(--shadow)`}
                      children={[
                        <div
                          className={`flex flex-wrap items-center gap-2`}
                          children={[
                            <span
                              className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                              children={e.titulo}
                            />,
                            <span
                              className={`rounded-full px-2 py-0.5 text-xs ${Qx(e.estado)}`}
                              children={Yx(e.estado)}
                            />,
                          ]}
                        />,
                        <p
                          className={`mt-1 text-xs text-(--text)`}
                          children={[
                            pS(e.fechaHora),
                            ` · `,
                            Yx(e.modalidad),
                            ` · `,
                            e.participantes?.length ?? 0,
                            ` participantes`,
                          ]}
                        />,
                        e.proyectosTratados?.length > 0 && (
                          <p
                            className={`mt-0.5 truncate text-xs text-(--text)`}
                            children={[
                              `Sobre `,
                              e.proyectosTratados.join(`, `),
                            ]}
                          />
                        ),
                        e.sedes?.length > 1 && (
                          <span
                            className={`mt-1 flex flex-wrap gap-1`}
                            children={e.sedes.map((e) => (
                              <Componente_qD_113_68
                                key={e.sedeId}
                                sedeId={e.sedeId}
                                nombre={e.nombre}
                              />
                            ))}
                          />
                        ),
                      ]}
                    />
                  }
                />
              ))}
            />
          ),
          !n && <Paginacion pagina={a} tamano={25} total={s} onChange={o} />,
          g && (
            <NuevaReunion
              proyectoId={e.id ?? null}
              unidadId={n ? e.unidadId : null}
              proyectosPosibles={n ? t : []}
              onClose={() => _(!1)}
              onGuardado={C}
            />
          ),
          v && (
            <DetalleReunion
              id={v}
              soloLectura={S}
              onClose={() => y(null)}
              onCambio={C}
              onCrearTarea={(e) => {
                (y(null), x(e));
              }}
            />
          ),
          b && (
            <DetalleTarea
              proyecto={e}
              tarea={null}
              preset={b}
              metas={l}
              onClose={() => x(null)}
              onGuardado={() => {
                (x(null), C());
              }}
            />
          ),
        ]}
      />
    )
  );
}
